import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import UpdatePasswordForm from './UpdatePasswordForm';
import { actions as authActions } from '../../../../services/auth/reducer';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

const FORM_NAME = 'manage_account';

class ManageAccount extends React.Component {
  private handleSubmit = (formValues) => {
    const { actions, destroy } = this.props;

    return actions.auth.updateCustomerPassword(
      formValues.currentPassword,
      formValues.newPassword,
      formValues.newPasswordConfirmation,
      () => {
        destroy(FORM_NAME);
      },
    );
  }

  public render() {
    return (
      <div className="page-container">

        <div className={'accessibility-support-container'}>
          <h3>Accessibility and Support</h3>
          <div className={'accessibility-support'}>
            We want to make sure it’s as easy as possible for everyone to use our products and services. We are
            continuously trying to improve our accessibility for people who have disabilities, long term health
            conditions, or are struggling with challenging times. For more information visit our <a
            href={'https://www.admiral.com/accessibility'} target={'_blank'}>accessibility and
            support</a> page.
          </div>
        </div>

        <div className="change-password-container">
          <h3>Update Password</h3>
          <div>
            <UpdatePasswordForm onSubmit={this.handleSubmit}/>
          </div>
        </div>
      </div>

    );
  }
}

export default flow([
  reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {

    return component;
  },
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ManageAccount);
